import React from 'react';
import { Link } from 'react-router-dom';
import { Phone } from 'lucide-react';
export function SelfDefenseFinalCTA() {
  return <section className="relative py-24 overflow-hidden bg-ink" data-id="element-2976">
      {/* Abstract diagonal background accent */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-charcoal transform skew-x-12 translate-x-20 opacity-50 pointer-events-none" data-id="element-2977" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-2978">
        <h2 className="text-4xl md:text-5xl text-white mb-6" data-id="element-2979">
          Want to Learn More About Self-Defense at Storm?
        </h2>
        <p className="text-xl text-gray-warm mb-10 max-w-2xl mx-auto" data-id="element-2980">
          Ask about our adult self-defense focused training. Storm will help you
          find a supportive starting point that matches your goals.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-2981">
          <Link to="/SignMeUp" className="btn-primary w-full sm:w-auto" data-id="element-2982">
            Claim Your Free Week
          </Link>
          <a href="tel:517-220-0621" className="btn-outline border-gray-warm text-white hover:bg-white hover:text-ink w-full sm:w-auto gap-2" data-id="element-2983">
            <Phone className="w-5 h-5" data-id="element-2984" />
            Call 517-220-0621
          </a>
        </div>
      </div>
    </section>;
}